import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
var _excluded = ["actions"];
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { forwardRef } from 'react';
import { ActionMenu } from '@rexlabs/action-menu';
import Icons from '@rexlabs/icons';
import { PrimaryButton, OutlineButton, GhostButton, PrimaryIconButton, OutlineIconButton, GhostIconButton, ButtonGroup } from '@rexlabs/button';
var _ref = Icons,
    ArrowDownFilled = _ref.ArrowDownFilled;
var triggersWithLabel = {
  primary: PrimaryButton,
  secondary: OutlineButton,
  tertiary: GhostButton
};
var triggerWithoutLabel = {
  primary: PrimaryIconButton,
  secondary: OutlineIconButton,
  tertiary: GhostIconButton
};
export function ActionButtons(_ref2) {
  var actions = _ref2.actions,
      props = _objectWithoutProperties(_ref2, _excluded);

  return /*#__PURE__*/React.createElement(ButtonGroup, _extends({
    flexWrap: "wrap"
  }, props), _mapInstanceProperty(actions).call(actions, function (_ref3, index) {
    var label = _ref3.label,
        _ref3$type = _ref3.type,
        type = _ref3$type === void 0 ? 'secondary' : _ref3$type,
        subActions = _ref3.actions,
        handleAction = _ref3.handleAction,
        Icon = _ref3.Icon,
        ActionTrigger = _ref3.ActionTrigger;
    var Button;
    var buttonProps = {};

    if (ActionTrigger) {
      Button = ActionTrigger;
    } else if (label) {
      Button = triggersWithLabel[type];
      buttonProps = {
        IconLeft: Icon
      };
    } else {
      Button = triggerWithoutLabel[type];
      buttonProps = {
        Icon: Icon
      };
    }

    if (subActions) {
      return /*#__PURE__*/React.createElement(ActionMenu, {
        items: subActions,
        Button: /*#__PURE__*/forwardRef(function ActionMenuButton(props, ref) {
          return /*#__PURE__*/React.createElement(Button, _extends({}, props, buttonProps, {
            ref: ref,
            IconRight: label && ArrowDownFilled
          }), label);
        })
      });
    }

    return /*#__PURE__*/React.createElement(Button, _extends({}, buttonProps, {
      key: index,
      onClick: handleAction
    }), label);
  }));
}